"use strict";

var _UserAvatarLoading, _AsyncBoundary;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { Portal } from '@autoguru/overdrive';
import { lazy, useLayoutEffect, useState } from 'react';
import { AsyncBoundary } from '@autoguru/suspense';
import { userMenuElementId } from './UserMenuHolder';
import { useAuth } from '@autoguru/auth';
import { UserAvatarLoading } from './UserAvatarLoading';
import { jsx as _jsx } from "react/jsx-runtime";
const LoggedInUserMenu = /*#__PURE__*/lazy(async () => import('./LoggedInUserMenu'));
const UnAuthedUserMenu = /*#__PURE__*/lazy(async () => import('./UnAuthedUserMenu'));
// Usage:
// STEP 1: Add <UserMenuHolder /> to the usage site of the user menu. This does not have to be behind auth
// STEP 2: Include this anywhere inside an authed component

const UserMenu = t0 => {
  const $ = _c(8);
  if ($[0] !== "e1823a0acaf9448582ee222d95458274c74d880d76682b0e27fa86c9e9927794") {
    for (let $i = 0; $i < 8; $i += 1) {
      $[$i] = Symbol.for("react.memo_cache_sentinel");
    }
    $[0] = "e1823a0acaf9448582ee222d95458274c74d880d76682b0e27fa86c9e9927794";
  }
  const {
    myGarage: t1,
    urlLogoutRedirect: t2
  } = t0;
  const myGarage = t1 === undefined ? false : t1;
  const urlLogoutRedirect = t2 === undefined ? null : t2;
  const [shouldMount, setShouldMount] = useState(false);
  const {
    isAuthenticated
  } = useAuth();
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setShouldMount(Boolean(document.querySelector(`#${userMenuElementId}`)));
    t4 = [];
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  useLayoutEffect(t3, t4);
  let t5;
  if ($[3] !== isAuthenticated || $[4] !== myGarage || $[5] !== shouldMount || $[6] !== urlLogoutRedirect) {
    t5 = shouldMount ? /*#__PURE__*/_jsx(Portal, {
      container: document.querySelector(`#${userMenuElementId}`),
      children: isAuthenticated ? /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: _UserAvatarLoading || (_UserAvatarLoading = /*#__PURE__*/_jsx(UserAvatarLoading, {})),
        children: /*#__PURE__*/_jsx(LoggedInUserMenu, {
          myGarage: myGarage,
          urlLogoutRedirect: urlLogoutRedirect
        })
      }) : _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
        fallback: /*#__PURE__*/_jsx(UserAvatarLoading, {}),
        children: /*#__PURE__*/_jsx(UnAuthedUserMenu, {})
      }))
    }) : null;
    $[3] = isAuthenticated;
    $[4] = myGarage;
    $[5] = shouldMount;
    $[6] = urlLogoutRedirect;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default UserMenu;